import { Pipe, PipeTransform } from '@angular/core';
import { isUndefined, padStart } from '@sama/micro-dash';

@Pipe({
  name: 'secondsToTime',
  standalone: false,
})
export class SecondsToTimePipe implements PipeTransform {
  transform(totalSeconds?: number) {
    if (isUndefined(totalSeconds)) {
      return '';
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds / 60) % 60);
    const seconds = Math.floor(totalSeconds % 60);

    let hoursString;
    if (hours > 0) {
      hoursString = padStart(`${hours}`, 2, '0');
    } else {
      hoursString = '';
    }

    const minutesString = padStart(`${minutes}`, 2, '0');
    const secondsString = padStart(`${seconds}`, 2, '0');

    if (hoursString) {
      return `${hoursString}:${minutesString}:${secondsString}`;
    }
    return `${minutesString}:${secondsString}`;
  }
}
